import React from 'react';

const NotFoundPage = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '270px' , marginBottom: "250px"}}>
      <h1>404 - Page Not Found</h1>
      <p>Oops! The page you're looking for doesn't exist.</p>
      <a href="/">Go to Home</a>
    </div>
  );
};

export default NotFoundPage;

